<template>
  <div class="app">
    <Header class="header" :resData="pagedata.nav" v-if="datatype !== 'privacy-yy'"></Header>
    <div class="main">
      <component :resData="pagedata[datatype]" :is="mainshow"></component>
    </div>
    <Footer :resData="pagedata.footer"></Footer>
  </div>
</template>

<script>
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import index from "@/components/top.vue";
import product from "@/components/product.vue";
import company from "@/components/company.vue";
import games from "@/components/games.vue";
import news from "@/components/news.vue";
import newDetails from "@/components/new-details.vue";
import aboutUs from "@/components/aboutUs.vue";
import privacyYy from "@/pages/privacy/privacy-yy.vue";
export default {
  data() {
    return {
      languages: "english",
      allData: "",
      pagedata: "",
      mainshow: "index",
      datatype: "index",
      show: true,
    };
  },
  components: {
    Header,
    Footer,
    index,
    product,
    company,
    games,
    news,
    aboutUs,
    newDetails,
    privacyYy,
  },
  watch: {
    $route(to, from) {
      this.mainshow = this.$route.name;
      this.datatype = this.$route.name;
      if (this.datatype === "newDetails") {
        this.datatype = "news";
      }
    },
  },
  methods: {
    mainfun(type) {
      this.mainshow = type;
    },
    languagefun(val) {
      this.$cookieStore.addCookie("languages", val, 1);
      this.pagedata = this.allData[val];
      if (this.mainshow === "index") {
        window.location.reload();
      }
    },
    getlan() {
      if (
        this.$cookieStore.getCookie("languages") &&
        this.$cookieStore.getCookie("languages") != undefined
      ) {
        this.languages = this.$cookieStore.getCookie("languages");
      }
      this.axios.get("/static/language.json").then((res) => {
        this.allData = res.data.data;
        this.pagedata = res.data.data[this.languages];
      });
    },
  },
  mounted() {
    this.mainshow = this.$route.name;
    this.datatype = this.$route.name;
    if (this.datatype === "newDetails") {
      this.datatype = "news";
    }
  },
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.header {
  height: 105px;
}
.footer {
  height: 220px;
}
.main {
  flex: 1;
}

@media screen and (max-width: 1000px) {
  .app {
    max-width: 750px;
    margin: auto;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue